import { Store } from "vuex";
import modules from "./modules";
import cmsGlobalStore from "./global";
// import mutationTypes from './mutation-types';

// Object.defineProperty(Store.prototype, 'mutationTypes', {
// 	enumerable: false,
// 	writable: false,
// 	configurable: false,
// 	value: mutationTypes
// });

const initState = (state, data) => {
  const _state = JSON.parse(JSON.stringify(state));

  _state.language = data.language;

  return _state;
};

export const create = (initialData = {}, storeModules = [], storePlugins = [], appGlobalStore = {}) => {
  const _modules = {};

  Object.entries({ ...modules, ...storeModules }).forEach(([moduleNameSpace, module]) => {
    _modules[moduleNameSpace] = {
      ...module,
      state: JSON.parse(JSON.stringify(module.state)),
    };
  });

  return new Store({
    // namespaced: true,
    strict: process.env.NODE_ENV !== "production",
    state: initState(
      {
        ...cmsGlobalStore.state,
        ...(appGlobalStore.state || {}),
      },
      initialData
    ),
    plugins: storePlugins,
    getters: {
      ...cmsGlobalStore.getters,
      ...(appGlobalStore.getters || {}),
    },
    mutations: {
      ...cmsGlobalStore.mutations,
      ...(appGlobalStore.mutations || {}),
    },
    actions: {
      ...cmsGlobalStore.actions,
      ...(appGlobalStore.actions || {}),
    },
    modules: _modules,
  });
};
